/** 수수료율 표시 — 값이 없으면(거래 불가 · 미확정) "-%" (M-11 카드 규칙). 32 = 32%라 다시 곱하지 않는다 */
export const formatFeeRate = (rate?: number | null) =>
  rate == null ? '-%' : `${Math.round(rate * 10) / 10}%`;

/** 의약품 정보가 없는 품목(코드 "-" 또는 ru…)은 상세를 열 수 없다 */
export const isLinkableDrugCode = (
  drugCode?: string | null,
): drugCode is string =>
  !!drugCode && drugCode !== '-' && !drugCode.startsWith('ru');

/** 화면에 보이는 약품 코드 — ru로 시작하는 코드는 "—" (요청에는 원본을 쓴다) */
export const displayDrugCode = (drugCode?: string | null) =>
  !drugCode || drugCode === '-' || drugCode.startsWith('ru') ? '—' : drugCode;

/** 브레드크럼용 짧은 이름 — "글루코바이정 100밀리그람 (0.1g/1정)" → "글루코바이정" */
export const shortDrugName = (drugName: string) =>
  drugName.split(/[\s(]/)[0] || drugName;

/** 대조약 · 생동인정 표시 글자 — v1.0은 배지 대신 메타 줄(DrugMeta) 맨 앞에 쓴다 */
export const drugKindLabels = (d: {
  referenceDrug: boolean;
  bioequivalent: boolean;
}) => [d.referenceDrug && '대조약', d.bioequivalent && '생동인정'];
